import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconSavingBank = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
            <StyledPath
                d="M.5 16h15M.5 13.333h15M1.333 7.333v4M3.667 7.333v4M6.833 7.333v4M9.166 7.333v4M12.334 7.333v4M14.666 7.333v4M15.5 5.333H.5l6.96-4.166a.993.993 0 0 1 1.08 0l6.96 4.166Z"
                color={color}
            />
            <defs>
                <clipPath id="a">
                    <path fill="transparent" d="M0 .5h16v16H0z" />
                </clipPath>
            </defs>
        </StyledStrokedGroup>
    </StyledSvg>
);
